import dateConverter from "../utils/converters/date.converter";
import {i18n} from "../plugins/vue-i18n";

const dateFormatted = {};
dateFormatted.install = Vue => {
  Vue.filter('dateFormatted', (value, param) => {
    let dateType = 'default';
    let date = value;
    if(param != null) {
      dateType = param;
    }

    if(typeof date === 'string') {
      date = dateConverter.convertToDate(date);
    }

    return i18n.d(date, dateType);
  });
};

export default dateFormatted;
